// Any modules that should be added to the wrapper application's AppModule
// should be exported here as an array.
//
// This is useful for when you have named router-outlets used inside dialogs.

import { GoogleAdWorkflowModule } from '@google-ad/modules/google-ad-workflow/google-ad-workflow.module';

export default [GoogleAdWorkflowModule];
